<script setup lang="ts">
import { TabsList, type TabsListProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends ClassProps, TabsListProps {}
const props = defineProps<Props>();

const delegatedProps = useDelegatedProps(props);
</script>

<template>
	<TabsList :class="cn('tabs-border tabs', props.class)" v-bind="delegatedProps">
		<slot />
	</TabsList>
</template>
